import { render, staticRenderFns } from "./bank-account-form-section.vue?vue&type=template&id=25eb87dd&lang=pug"
import script from "./bank-account-form-section.vue?vue&type=script&lang=ts"
export * from "./bank-account-form-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports